<button mat-raised-button  *appRole="['CuentasContable.Crear']" color="primary" [routerLink]="['/cuentascontable']">
    <mat-icon>add</mat-icon>
    Nueva cuenta contable
</button>
